import { Sede } from '@components/contatti/sede/sede';
import { Tooltip } from '@components/contatti/tooltip/tooltip';
import { TooltipContent } from '@components/contatti/tooltip-content/tooltip-content';
import React from 'react';

const MappingSediMobile = ({ sedi }) => {
  return (
    <>
      {sedi?.map((sede) => (
        <React.Fragment key={sede.info.citta}>
          <Sede
            citta={sede.info.citta}
            x={sede.marker.coordinates.x}
            y={sede.marker.coordinates.y}
            onMouseLeave={() => {}}
            onMouseEnter={() => {}}
            onFocus={() => {}}
          />
          <Tooltip
            width="325"
            height="115"
            xshift={sede.tooltip.coordinates.x}
            yshift={sede.tooltip.coordinates.y}
            show
          >
            <TooltipContent
              indirizzo={sede.info.indirizzo}
              cap={sede.info.cap}
              // email={sede.info.email}
              phone={sede.info.phone}
              onBlur={() => {}}
              onMouseLeave={() => {}}
            />
          </Tooltip>
        </React.Fragment>
      ))}
    </>
  );
};

MappingSediMobile.displayName = 'Mapping Sedi Mobile';
export { MappingSediMobile };
